import type { Anomaly } from '@soc/shared';
import { useInvestigateAlert } from './useInvestigateAlert';

/**
 * A compact 🔍 button for one cluster-popup member. Renders nothing for rules
 * that don't support investigation, so the cluster list stays clean.
 */
export function InvestigateMemberButton({ alert }: { alert: Anomaly }) {
  const { canInvestigate, investigate } = useInvestigateAlert(alert);
  if (!canInvestigate) return null;
  return (
    <button
      type="button"
      title="Investigate"
      onClick={(e) => {
        e.stopPropagation();
        investigate();
      }}
      style={{
        flex: 'none',
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        fontSize: 12,
        background: 'var(--surface-app)',
        border: '1px solid var(--border-hover)',
        borderRadius: 6,
        cursor: 'pointer',
      }}
    >
      🔍
    </button>
  );
}
